import gql from 'graphql-tag';

// QUERIES

export const GET_BOOKLETS_WITH_SERIES = gql`
  query GetBookletsWithSeries($zoneId: ObjectId!) {
    bookletSeriesInZone(zoneId: $zoneId) {
      _id
      name
      logoURL
      logoFullURL
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      mainAssociationId
      purchasableThroughAssociations
      totalCommission
      supportCommissionToAssociation
      supportCommissionToMainAssociation
      adminEmails
      defaultValidityMonths
      totalSoldBooklets
      currentBooklet {
        _id
        title
      }
      nextBooklet {
        _id
        title
      }
      booklets {
        _id
        title
        subtitle
        logoURL
        buyableFrom
        buyableTo
        validFrom
        validTo
        colorLeft
        colorRight
        colorFont
        colorSalesMaterial
        price
        usedOrders
        soldBooklets
        adminEmails
        bookletSeriesId
        mainAssociationId
        purchasableThroughAssociations
        totalCommission
        supportCommissionToAssociation
        supportCommissionToMainAssociation
        couponIds
        sponsors { name }
        categorySettings { categoryId }
        shouldSendStatsMail
      }
    }

    bookletsInZone(zoneId: $zoneId) {
      _id
      title
      subtitle
      logoURL
      buyableFrom
      buyableTo
      validFrom
      validTo
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      usedOrders
      soldBooklets
      bookletSeriesId
      adminEmails
      shouldSendStatsMail
    }
  }
`;

// MUTATIONS

export const CREATE_BOOKLET_SERIES = gql`
  mutation CreateBookletSeries(
    $name: String!
    $zoneId: ObjectId!
    $adminEmails: [String!]
    $price: Float
    $mainAssociationId: ObjectId
    $purchasableThroughAssociations: [ObjectId!]
    $totalCommission: Float
    $supportCommissionToAssociation: Float
    $supportCommissionToMainAssociation: Float
    $logoURL: String
    $colorLeft: String
    $colorRight: String
    $colorFont: String
    $colorSalesMaterial: String
    $defaultValidityMonths: Int
  ) {
    createBookletSeries(
      name: $name
      zoneId: $zoneId
      adminEmails: $adminEmails
      price: $price
      mainAssociationId: $mainAssociationId
      purchasableThroughAssociations: $purchasableThroughAssociations
      totalCommission: $totalCommission
      supportCommissionToAssociation: $supportCommissionToAssociation
      supportCommissionToMainAssociation: $supportCommissionToMainAssociation
      logoURL: $logoURL
      colorLeft: $colorLeft
      colorRight: $colorRight
      colorFont: $colorFont
      colorSalesMaterial: $colorSalesMaterial
      defaultValidityMonths: $defaultValidityMonths
    ) {
      _id
      name
      logoURL
      logoFullURL
      booklets {
        _id
        title
      }
    }
  }
`;

export const UPDATE_BOOKLET_SERIES = gql`
  mutation UpdateBookletSeries(
    $_id: ObjectId!
    $name: String
    $adminEmails: [String!]
    $price: Float
    $mainAssociationId: ObjectId
    $purchasableThroughAssociations: [ObjectId!]
    $totalCommission: Float
    $supportCommissionToAssociation: Float
    $supportCommissionToMainAssociation: Float
    $logoURL: String
    $colorLeft: String
    $colorRight: String
    $colorFont: String
    $colorSalesMaterial: String
    $defaultValidityMonths: Int
  ) {
    updateBookletSeries(
      _id: $_id
      name: $name
      adminEmails: $adminEmails
      price: $price
      mainAssociationId: $mainAssociationId
      purchasableThroughAssociations: $purchasableThroughAssociations
      totalCommission: $totalCommission
      supportCommissionToAssociation: $supportCommissionToAssociation
      supportCommissionToMainAssociation: $supportCommissionToMainAssociation
      logoURL: $logoURL
      colorLeft: $colorLeft
      colorRight: $colorRight
      colorFont: $colorFont
      colorSalesMaterial: $colorSalesMaterial
      defaultValidityMonths: $defaultValidityMonths
    ) {
      _id
      name
      logoURL
      logoFullURL
      defaultValidityMonths
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      mainAssociationId
      purchasableThroughAssociations
      totalCommission
      supportCommissionToAssociation
      supportCommissionToMainAssociation
    }
  }
`;

export const DELETE_BOOKLET_SERIES = gql`
  mutation DeleteBookletSeries($_id: ObjectId!) {
    deleteBookletSeries(_id: $_id)
  }
`;
